import Header from "./header2";
import "./ex.css"

export default function Projects() {
  return (
    <div className="excont" > 
      <Header />
      {/* <Cardlist /> */}
      <p>
        {" "}
        Our company participated in various international exhibitions. One of
        them is ISNR - International Exhibition for National Security and
        Resilience, helded in Abu Dhabi, UAE. ISNR Abu Dhabi is the region’s
        most trusted platform bringing together national & cyber security
        officials, buyers and all supply chain stakeholders from public and
        private sectors, to conduct business, enhance industry leadership and
        showcase innovation to discuss & influence future projects.
      </p>
    </div>
  );
}
